import { getContentResources, registerUsedContent } from '../../services/RegisterUse'
import { isError } from '../../utils/api'

export default {
  state: {
    programId: null,
    programName: null,
    resourceId: null,
    resources: null
  },

  mutations: {
    hydrateContentResources(state, { data, resourceId }) {
      state.programId = data.id
      state.programName = data.name
      state.resources = data.resources
        .filter(res => resourceId ? res.id === resourceId : res)
        .map(res => ({
          ...res,
          used: false,
          classPlans: res.classPlans ? res.classPlans.map(resClass => ({ ...resClass, used: false })) : null
        }))
    },
    toggleUsedContent(state) {
      const isUsed = state.resources.every(res => res.used || (res.classPlans && res.classPlans.every(resClass => resClass.used)))
      state.resources = state.resources.map(res =>
        ({
          ...res,
          used: res.classPlans ? false : !res.used,
          classPlans: res.classPlans ? res.classPlans.map(resClass => ({ ...resClass, used: !isUsed })) : null
        })
      )
    },
    toggleUsedResource(state, resourceId) {
      const resource = state.resources.find(res => res.id === resourceId)
      const isUsed = resource.used || (resource.classPlans && resource.classPlans.every(resClass => resClass.used))
      state.resources = state.resources.map(res => res.id === resourceId
        ? {
          ...res,
          used: res.classPlans ? false : !res.used,
          classPlans: res.classPlans ? res.classPlans.map(resClass => ({ ...resClass, used: !isUsed })) : null
        }
        : res
      )
    },
    toggleUsedClass(state, { resourceId, classId }) {
      state.resources = state.resources.map(res => res.id === resourceId
        ? {
          ...res,
          classPlans: res.classPlans.map(resClass => resClass.id === classId ? { ...resClass, used: !resClass.used } : resClass)
        }
        : res
      )
    }
  },

  actions: {
    toggleUsedContent({ commit }) {
      commit('toggleUsedContent')
    },
    toggleUsedResource({ commit }, resourceId) {
      commit('toggleUsedResource', resourceId)
    },
    toggleUsedClass({ commit }, { resourceId, classId }) {
      commit('toggleUsedClass', { resourceId, classId })
    },
    async hydrateContentResources({ commit }, { programId, resourceId, locale }) {
      const response = await getContentResources({ programId, locale }).catch(e => e.response)
      const success = !isError(response.status)
      if (success) commit('hydrateContentResources', { data: response.data, resourceId })
      return success
    },
    async registerUsedContent({ state }, { recordInfo, fromProgram }) {
      const educationalProgramCompleted = fromProgram && Boolean(state.resources.every(res => res.classPlans.every(resClass => resClass.used)))
      const response = await registerUsedContent({
        ...recordInfo,
        educationalProgramId: state.programId,
        educationalProgramCompleted,
        usedContentRecordResources: !educationalProgramCompleted
          ? state.resources
            .map(res => {
              const allResource = Boolean(res.used || (res.classPlans && res.classPlans.every(resClass => resClass.used)))
              return ({
                resourceId: res.id,
                resourceCompleted: allResource,
                classPlans: allResource ? null : res.classPlans.filter(resClass => resClass.used).map(resClass => ({ id: resClass.id }))
              })
            })
            .filter(res => res.resourceCompleted || res.classPlans.length)
          : null
      })
      const success = !isError(response.status)
      return success
    }
  }
}
